const portraitArr = [
  {
    photoID: 1,
    imgUrl: require("@/assets/portrait/1.png")
  },
  {
    photoID: 2,
    imgUrl: require("@/assets/portrait/2.png")
  },
  {
    photoID: 3,
    imgUrl: require("@/assets/portrait/3.png")
  },
  {
    photoID: 4,
    imgUrl: require("@/assets/portrait/4.png")
  },
  {
    photoID: 5,
    imgUrl: require("@/assets/portrait/5.png")
  },
  {
    photoID: 6,
    imgUrl: require("@/assets/portrait/6.png")
  },
  {
    photoID: 7,
    imgUrl: require("@/assets/portrait/7.png")
  },
  {
    photoID: 8,
    imgUrl: require("@/assets/portrait/8.png")
  },
  {
    photoID: 9,
    imgUrl: require("@/assets/portrait/9.png")
  }
];
const infolist = [
  {
    id: 1,
    imgUrl: require("@/assets/oldKhy/1.png"),
    title: "考生账号",
    data: "1111111"
  },
  {
    id: 2,
    imgUrl: require("@/assets/oldKhy/2.png"),
    title: "考生姓名",
    data: "1111111"
  },
  {
    id: 3,
    imgUrl: require("@/assets/oldKhy/3.png"),
    title: "科室",
    data: "1111111"
  },
  {
    id: 3,
    imgUrl: require("@/assets/oldKhy/3.png"),
    title: "职称",
    data: "1111111"
  }
];

export { portraitArr,infolist };
